/* MRPIECE Winter 26 — small progressive enhancements.
   1. Strips emoji from product titles inside mw-* sections.
   2. Scroll reveal for mw-* content (never hides what is already on screen).
   3. Soft parallax on the hero mosaic.
   4. Camel ring cursor on desktop pointers.
   Everything respects prefers-reduced-motion. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1 — clean titles */
  var re = /[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{200D}\u{20E3}]/gu;
  function clean(root) {
    (root || document).querySelectorAll('[data-mw-clean]').forEach(function (el) {
      var t = el.textContent.replace(re, '').replace(/\s{2,}/g, ' ').trim();
      t = t.replace(/^[\s|·–—-]+|[\s|·–—-]+$/g, '').trim();
      if (t) el.textContent = t;
    });
  }

  /* 2 — reveal */
  var SEL = '.mw__head, .mw-card, .mw-tile, .mw-split__panel, .mw-brand, .mw-banner__inner, .mw-hero__copy';
  var io = null;
  function reveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    var vh = window.innerHeight || 800;
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.hasAttribute('data-mw-reveal')) return;
      var parent = el.parentElement;
      var i = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.setProperty('--mw-i', Math.min(i, 6));
      el.setAttribute('data-mw-reveal', '');
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); } else { io.observe(el); }
    });
    doc.classList.add('mw-reveal-ready');
  }

  /* 3 — hero parallax */
  function parallax() {
    if (reduce) return;
    var tiles = document.querySelectorAll('.mw-hero__tile img');
    if (!tiles.length) return;
    var ticking = false;
    function update() {
      var y = window.scrollY || 0;
      if (y < 900) {
        tiles.forEach(function (img, i) {
          var k = [0.06, -0.04, 0.03][i] || 0.03;
          img.style.translate = '0 ' + (y * k).toFixed(1) + 'px';
        });
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* 4 — cursor */
  function cursor() {
    if (reduce) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (document.querySelector('.mw-cursor')) return;
    var ring = document.createElement('div'); ring.className = 'mw-cursor';
    var dot = document.createElement('div'); dot.className = 'mw-cursor-dot';
    ring.setAttribute('aria-hidden', 'true'); dot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ring); document.body.appendChild(dot);
    var mx = -100, my = -100, rx = -100, ry = -100;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
      doc.classList.add('mw-cursor-on');
    }, { passive: true });
    document.addEventListener('mouseleave', function () { doc.classList.remove('mw-cursor-on'); });
    document.addEventListener('mouseover', function (e) {
      var hit = e.target.closest && e.target.closest('a, button, [role="button"], input, select, label, summary');
      doc.classList.toggle('mw-cursor-hover', !!hit);
    });
    (function loop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  function init() { clean(); reveal(); parallax(); cursor(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { clean(e.target); reveal(e.target); });
})();
